import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";
import { authGuard } from "./guards";

const Login = lazy(() => import("../views/default/Login"));

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  beforeLoad: authGuard({ publicOnly: true }),
  component: Login,
});
